import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: LucideIcon;
  color: string;
}

const MetricCard: React.FC<MetricCardProps> = ({ title, value, change, trend, icon: Icon, color }) => {
  const isNoData = value === 'No data';
  const isVersion = title === 'Version';
  
  return (
    <div className="metric-card">
      <div className="metric-header">
        <h3 className="metric-title">{title}</h3>
      </div>
      
      <div className="metric-content">
        <div 
          className={`metric-value ${isNoData ? 'no-data' : ''} ${isVersion ? 'version' : ''}`}
          style={{ 
            color: isNoData ? '#10b981' : isVersion ? '#ffffff' : '#ffffff',
            fontSize: isNoData ? '2.5rem' : isVersion ? '4rem' : '3rem',
            fontWeight: isVersion ? '300' : 'normal'
          }}
        >
          {value}
        </div>
        {change !== '--' && (
          <div className={`metric-change ${trend}`}>
            <span>{change}</span>
            <span className="metric-period">vs last period</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricCard;
